export default __webpack_public_path__ + "static/media/IMG_1662.26280326.jpeg";